export default __webpack_public_path__ + "static/media/addplus-btn.8d952c1b.svg";